import { ParagraphProps } from '../../../components/PageBuilder/Paragraph/Paragraph';
import WhatISImage from '../../../assets/images/unique/Neural Therapy/Neural_therapy.jpg';

export const NeuralTherapyParagraphs: ParagraphProps[] = [
  {
    title: 'What it consists of',
    text: `Pain care starts by understanding pain as information, not only as a sensation. A consultation may explore tissue irritation, movement patterns, previous injuries, nerve sensitivity, inflammation, stress, sleep disruption, and protective habits the body has learned over time.`,
    img: WhatISImage,
  },
  {
    title: 'What it may help clarify',
    text: `This topic may help organize questions around chronic discomfort, mobility limitations, muscle tension, previous injuries, nerve-like symptoms, headaches, posture-related pain, or pain that changes with stress, sleep, or activity.`,
  },
  {
    title: 'What is reviewed in consultation',
    text: `Important clues include location, duration, triggers, numbness or weakness, previous treatments, imaging, medications, posture, daily function, stress, and whether pain changes with movement. Function often tells a clearer story than a pain score alone.`,
  },
  {
    title: 'What to keep in mind',
    text: `Pain care should be individualized. Depending on the case, the conversation may involve medical evaluation, movement strategies, lifestyle support, referral, medication review, or other options. The aim is comfort, mobility, and safer decision-making.`,
  },
];
